/* UrbanLaws cart drawer: sliders, gift/upsell add, variant picker, note, gift guard.
   Works on top of the theme's own drawer (assets/cart.js): every cart change goes through
   MinimogEvents cartUpdate, which re-renders #MinimogCartDrawerHeader/Body/Footer. */
(function () {
  if (window.ULCartDrawer) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var state = { busy: false, noteOpen: false, pickerItem: null };

  function drawer() { return document.getElementById('MinimogCartDrawer'); }

  function sectionsToRender() {
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } }));
    return sections;
  }

  function postJSON(path, body) {
    return fetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function emitCartUpdate(cart) {
    if (window.MinimogEvents && window.MinimogTheme) {
      window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: cart });
    }
  }

  function setLoading(on) {
    var d = drawer();
    if (d) d.classList.toggle('ul-cd--loading', !!on);
  }

  function showError(message) {
    var d = drawer();
    var target = d && d.querySelector('m-cart-items');
    if (window.MinimogTheme && window.MinimogTheme.Notification && target) {
      window.MinimogTheme.Notification.show({ target: target, method: 'prepend', type: 'warning', message: message || 'Bir hata oluştu, tekrar dene.', last: 3000 });
    }
  }

  function addToCart(variantId, kind) {
    if (state.busy) return Promise.resolve();
    state.busy = true;
    setLoading(true);
    var item = { id: Number(variantId), quantity: 1 };
    if (kind === 'gift') item.properties = { _ul_gift: '1' };
    return postJSON('cart/add.js', { items: [item], sections: sectionsToRender() })
      .then(function (res) {
        if (res && res.status) { showError(res.description || res.message); return; }
        closePicker();
        emitCartUpdate(res);
      })
      .catch(function () { showError(); })
      .then(function () { state.busy = false; setLoading(false); });
  }

  /* ---------- Gift guard: one gift, quantity 1, only above the gift goal ---------- */
  function giftLinesFromCart(cart) {
    return (cart.items || []).filter(function (i) {
      var p = i.properties || {};
      return p._ul_gift || p.__cd_opus_free_gift;
    });
  }

  function stateFromCart(cart) {
    var gifts = giftLinesFromCart(cart);
    var giftFinal = gifts.reduce(function (s, i) { return s + i.final_line_price; }, 0);
    var goalEl = document.querySelector('[data-ul-cart-state]');
    var goal = 1000000;
    if (goalEl) { try { goal = JSON.parse(goalEl.textContent).giftGoal || goal; } catch (e) {} }
    else if (window.ULCartGiftGoal) { goal = window.ULCartGiftGoal; }
    return { giftGoal: goal, unlock: cart.total_price - giftFinal, giftLines: gifts.map(function (i) { return { key: i.key, qty: i.quantity }; }) };
  }

  function readRenderedState() {
    var el = document.querySelector('#MinimogCartDrawerBody [data-ul-cart-state]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function guard(s) {
    if (!s || state.busy || !s.giftLines || !s.giftLines.length) return;
    var changes = [];
    if (s.unlock < s.giftGoal) {
      s.giftLines.forEach(function (l) { changes.push({ id: l.key, quantity: 0 }); });
    } else {
      s.giftLines.forEach(function (l, i) {
        if (i === 0) { if (l.qty > 1) changes.push({ id: l.key, quantity: 1 }); }
        else changes.push({ id: l.key, quantity: 0 });
      });
    }
    if (!changes.length) return;
    state.busy = true;
    setLoading(true);
    var last = null;
    var chain = Promise.resolve();
    changes.forEach(function (c) {
      chain = chain.then(function () {
        return postJSON('cart/change.js', { id: c.id, quantity: c.quantity, sections: sectionsToRender() }).then(function (res) { if (res && !res.status) last = res; });
      });
    });
    chain.catch(function () {}).then(function () {
      state.busy = false;
      setLoading(false);
      if (last) emitCartUpdate(last);
    });
  }

  function runGuard() {
    var s = readRenderedState();
    if (s) return guard(s);
    // Cart page (no drawer markup): ask the cart
    if (window.MinimogSettings && window.MinimogSettings.templateName === 'cart') {
      fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) { guard(stateFromCart(cart)); }).catch(function () {});
    }
  }

  document.addEventListener('cart:updated', function () { setTimeout(runGuard, 0); });

  /* ---------- Variant picker (bottom sheet) ---------- */
  function pickerEl() { var d = drawer(); return d && d.querySelector('.ul-cd__picker'); }

  function closePicker() {
    var p = pickerEl();
    if (p) { p.classList.remove('is-open'); setTimeout(function () { p.hidden = true; }, 250); }
    state.pickerItem = null;
  }

  function openPicker(productId, kind) {
    var dataEl = document.querySelector('[data-ul-product="' + productId + '"]');
    var p = pickerEl();
    if (!dataEl || !p) return false;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return false; }
    var first = data.variants.filter(function (v) { return v.available; })[0] || data.variants[0];
    state.pickerItem = { data: data, kind: kind, selected: first.options.slice() };

    p.querySelector('.ul-cd__picker-title').textContent = data.title;
    var opts = p.querySelector('.ul-cd__picker-options');
    opts.innerHTML = '';
    data.options.forEach(function (name, idx) {
      var values = [];
      data.variants.forEach(function (v) { if (values.indexOf(v.options[idx]) === -1) values.push(v.options[idx]); });
      var group = document.createElement('div');
      group.className = 'ul-cd__picker-group';
      var label = document.createElement('div');
      label.className = 'ul-cd__picker-label';
      label.textContent = name;
      group.appendChild(label);
      var row = document.createElement('div');
      row.className = 'ul-cd__picker-values';
      values.forEach(function (val) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ul-cd__picker-value';
        b.textContent = val;
        b.dataset.index = idx;
        b.dataset.value = val;
        row.appendChild(b);
      });
      group.appendChild(row);
      opts.appendChild(group);
    });
    renderPicker();
    p.hidden = false;
    requestAnimationFrame(function () { p.classList.add('is-open'); });
    return true;
  }

  function currentVariant() {
    var it = state.pickerItem;
    if (!it) return null;
    return it.data.variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === it.selected[i]; });
    })[0] || null;
  }

  function renderPicker() {
    var it = state.pickerItem, p = pickerEl();
    if (!it || !p) return;
    var v = currentVariant();
    p.querySelectorAll('.ul-cd__picker-value').forEach(function (b) {
      b.classList.toggle('is-selected', it.selected[Number(b.dataset.index)] === b.dataset.value);
    });
    var img = p.querySelector('.ul-cd__picker-img');
    var src = (v && v.image) || it.data.image;
    if (src) { img.src = src; img.hidden = false; } else { img.hidden = true; }
    var price = p.querySelector('.ul-cd__picker-price');
    if (it.kind === 'gift') {
      price.innerHTML = '<span class="ul-cd__free">Ücretsiz</span> <s></s>';
      price.querySelector('s').textContent = v ? v.was : '';
    } else {
      price.innerHTML = '<span></span> <s></s>';
      price.querySelector('span').textContent = v ? v.price : '';
      price.querySelector('s').textContent = v && v.compare ? v.compare : '';
    }
    var add = p.querySelector('.ul-cd__picker-add');
    var ok = !!(v && v.available);
    add.disabled = !ok;
    add.textContent = ok ? 'Sepete Ekle' : 'Tükendi';
  }

  /* ---------- Clicks inside the drawer ---------- */
  document.addEventListener('click', function (e) {
    var d = drawer();
    if (!d || !d.contains(e.target)) return;

    var close = e.target.closest('[data-ul-close], .ul-cd__close');
    if (close) { e.preventDefault(); closePicker(); d.close(); return; }

    var add = e.target.closest('[data-ul-add]');
    if (add) {
      e.preventDefault();
      if (add.dataset.ulPick && openPicker(add.dataset.ulPick, add.dataset.ulKind)) return;
      addToCart(add.dataset.ulAdd, add.dataset.ulKind);
      return;
    }

    var val = e.target.closest('.ul-cd__picker-value');
    if (val && state.pickerItem) {
      state.pickerItem.selected[Number(val.dataset.index)] = val.dataset.value;
      renderPicker();
      return;
    }
    if (e.target.closest('.ul-cd__picker-add')) {
      var v = currentVariant();
      if (v && v.available && state.pickerItem) addToCart(v.id, state.pickerItem.kind);
      return;
    }
    if (e.target.closest('.ul-cd__picker-close') || e.target.classList.contains('ul-cd__picker')) { closePicker(); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = drawer();
    if (!d || !d.classList.contains('m-cart-drawer--active')) return;
    if (state.pickerItem) closePicker(); else d.close();
  });

  /* ---------- Sliders (theme's Swiper) ---------- */
  if (!customElements.get('ul-cd-slider')) {
    customElements.define('ul-cd-slider', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        var container = this.querySelector('.swiper-container');
        if (!container || !window.MinimogLibs || !window.MinimogLibs.Swiper) return;
        var count = container.querySelectorAll('.swiper-slide').length;
        var delay = parseInt(this.dataset.autoplay || '0', 10);
        var dots = this.dataset.dots === 'true' ? this.querySelector('.ul-cd__dots') : null;
        this.slider = new window.MinimogLibs.Swiper(container, {
          slidesPerView: 1,
          speed: 1000,
          loop: count > 1,
          observer: true,
          observeParents: true,
          autoplay: delay && count > 1 ? { delay: delay, disableOnInteraction: false } : false,
          pagination: dots && count > 1 ? { el: dots, type: 'bullets', clickable: true } : false
        });
        var prev = this.querySelector('.ul-cd__nav--prev');
        var next = this.querySelector('.ul-cd__nav--next');
        if (count < 2) { if (prev) prev.hidden = true; if (next) next.hidden = true; }
        if (prev) prev.addEventListener('click', function () { self.slider && self.slider.slidePrev(); });
        if (next) next.addEventListener('click', function () { self.slider && self.slider.slideNext(); });
        if (window.MinimogEvents && window.MinimogTheme) {
          this.unsub = window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.openCartDrawer, function () {
            if (self.slider) { self.slider.update(); if (self.slider.autoplay && delay) self.slider.autoplay.start(); }
          });
        }
      }
      disconnectedCallback() {
        if (this.unsub) this.unsub();
        if (this.slider) { try { this.slider.destroy(true, true); } catch (e) {} this.slider = null; }
      }
    });
  }

  /* ---------- Note ---------- */
  if (!customElements.get('ul-cd-note')) {
    customElements.define('ul-cd-note', class extends HTMLElement {
      connectedCallback() {
        var toggle = this.querySelector('.ul-cd__note-toggle');
        var body = this.querySelector('.ul-cd__note-body');
        var area = this.querySelector('textarea');
        var self = this;
        function apply(open) {
          body.hidden = !open;
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          self.classList.toggle('is-open', open);
        }
        apply(state.noteOpen);
        toggle.addEventListener('click', function () { state.noteOpen = !state.noteOpen; apply(state.noteOpen); });
        var timer = null;
        area.addEventListener('input', function () {
          clearTimeout(timer);
          var value = area.value;
          timer = setTimeout(function () { postJSON('cart/update.js', { note: value }).catch(function () {}); }, 600);
        });
      }
    });
  }

  window.ULCartDrawer = { add: addToCart, guard: runGuard };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runGuard);
  else runGuard();
})();
